export enum HintVariant {
  Warning,
  Error,
  Success,
}
